import constants from "../utils/constants.json"

const getActiveEnv = () => {
    const currentUrl = window.location.href;
    console.log("currentUrl :" + currentUrl);
    const matchingEnv = Object.keys(constants.app).filter(key => {
        const found = constants.app[key].filter(url => currentUrl.indexOf(url) > -1)
        return found && found.length>0 ? true: false
    })
    if(matchingEnv && matchingEnv.length > 0){
        return matchingEnv[0];
    }
    console.log("using default env dev");
    return "dev";
}

const getActiveConfig = () =>{
    const activeEnv = getActiveEnv();
    if(activeEnv && constants.env[activeEnv]){
        return constants.env[activeEnv];
    }
    return constants.env.dev;
}

export const GLOBALS = {
    goLive: false,
    env: getActiveEnv(),
    config: getActiveConfig()
};



